import getSlug from 'speakingurl'

export default function createVideoSlug(videoName: string, rise?: boolean, storyline?: boolean): string {
  if (storyline && rise) {
    return getSlug(`360-${videoName}`)
  }
  if (storyline) {
    return getSlug(`storyline-360-${videoName}`)
  }
  if (rise) {
    return getSlug(`rise-360-${videoName}`)
  }

  return getSlug(videoName)
}
